import React from 'react';
import SeoArticlePage from './SeoArticlePage';

export default function IplPlayerPerformanceAnalyticsPage() {
  return (
    <SeoArticlePage
      title="IPL Player Performance Analytics | IPL Player Performance Analysis"
      description="IPL player performance analytics for fantasy trading: role-based metrics, venue splits, phase impact and consistency tracking."
      canonicalPath="/ipl-player-performance-analytics"
      keywords="ipl player performance analytics, ipl player performance analysis, ipl analytics, ipl player trading"
      heading="IPL Player Performance Analytics"
      intro="Good predictions come from repeatable metrics. IPL player performance analysis should compare role expectations against actual output by match phase."
      sections={[
        {
          title: 'High-Value Metrics',
          body: 'Track phase-specific metrics rather than only final scorecards.',
          bullets: ['Powerplay strike rate and dismissals', 'Middle-over spin vs pace split', 'Death-over boundary and wicket contribution'],
        },
        {
          title: 'Context Multipliers',
          body: 'Adjust every stat by opposition quality, pitch speed and toss condition. Raw averages alone create false confidence.',
        },
        {
          title: 'Portfolio Application',
          body: 'Use analytics to balance your portfolio with low-variance anchors and high-upside volatility picks.',
        },
      ]}
    />
  );
}
